import React from 'react'
import './SellerPanel.css'
import Usernav from './Usernav';
import Sellernav from './Sellernav';
import Adminnav from './Adminnav';
import { useNavigate } from 'react-router-dom';
const SellerPanel = () => {

  var nav=useNavigate()
  function navAddProducts(){
    nav('/SellerPanel/AddProducts')
  }
  function navigateProductCatlog(){
    nav('/SellerPanel/ProductCatlog')
  }
  function navigateUpdateProduct(){
    nav('/SellerPanel/UpdateStocks')
  }
  function navigateOrders(){
    nav('/SellerPanel/SalesReport')
  }
  return (
    <>
      <Sellernav/>
      <div className="card h-100 text-center panel" id='panel1'>
        <div className="card-body row ">
          <i onClick={()=>{navAddProducts()}} className="fas fa-plus icon col"></i>
          <i onClick={()=>{navigateProductCatlog()}} className="fas fa-database icon col"></i>
          {/* <i onClick={()=>{navigateUpdateProduct()}} className="fas fa-edit icon col"></i> */}
          <i onClick={()=>{navigateOrders()}} className="fas fa-truck icon col"></i>
        </div>
        <div className="card-body row content">
          <b className="col" style={{ paddingLeft: "3.0px" }} >Add Products</b>
          <b className="col">Update Catlog</b>
          {/* <b className="col" style={{ paddingLeft: "20px" }}>Update Stock</b> */}
          <b className="col">Orders</b>
        </div>
      </div>
    </>
  )
}

export default SellerPanel